'use client'

export default function GlobalError({ reset }: { error: Error & { digest?: string }, reset: () => void }) {
  return (
    <html lang="ko">
      <body>
        <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24, textAlign: 'center' }}>
          <div>
            <h1>서비스를 불러오지 못했습니다</h1>
            <p>잠시 후 다시 시도해 주세요.</p>
            <button type="button" onClick={reset}>다시 시도</button>
          </div>
        </main>
      </body>
    </html>
  )
}
